<template>
  <div class="gridTab">
    <sort v-if="!isSnapshot"
          :key="stateKeyValue" :tab="'grid'"
          :showCreate="showCreate"
          :reorderMode="reorderMode"
          @enterReorderMode="enterReorderMode"
          :postLimitExceeded="project && project.metadata ? project.metadata.posts > 50 : false"
          @savePosts="savePostsOrder"
          @resetPosts="resetPosts"
          :projectRole="projectRole" />
    <div class="backColor">
      <div class="grid-area">
        <infinite-scroll :callback="fetch" class="infiniteContainer">
          <draggable v-if="reorderMode" tag="ul" class="columns is-multiline" :list="displayPosts" :animation="400" ghost-class="moving-card">
            <li v-for="(post, offset) in displayPosts"
                class="column gridcolumns is-one-third reorder-mode"
                draggable="true"
                :key="post.id" :id="`post-${post.id}`" :data-post="post" :data-offset="offset">
              <post class="animated tada" :post="post"></post>
            </li>
          </draggable>
          <ul v-if="!reorderMode" class="no-reorder">
            <transition-group name="slide"
                              class="columns gridcolumns is-multiline is-mobile">
              <li v-for="(post, index) in displayPosts.slice(0,getIsefFinalist(displayPosts))"
                  :key="post.id"
                  class="column gridcolumn gridcolumnitem is-one-third"
                  :id="`post-${post.id}`">
                <post class="animated pulse postGrid"
                      tabindex="0" @keypress.enter.space="showPost"
                      :available="available"
                      :post="post"
                      :selected="post.id === selectedPostID"
                      :preloadForOnboarding="index===0"
                      :isSnapshot="isSnapshot"
                      @showPost="showPost"
                      @toggleModal="toggleModal"
                      @toggleAvailability="toggleAvailability"
                >
                </post>
              </li>
            </transition-group>
          </ul>
          <div v-if="postLoading">
            <span class="loader column gridcolumn is-fullwidth"></span>
          </div>
        </infinite-scroll>
      </div>
    </div>
    <grid-modal v-show="available" v-if="showModal"
                ref="gridModal"
                :postID="selectedPostID"
                :displayPosts="displayPosts"
                :getPostDirection="getPostDirection"
                :fromStartButtonTemplate="fromStartButtonTemplate"
                :isSnapshot="isSnapshot"
                @toggleAvailability="toggleAvailability"
                @scrollToPost="scrollToPost" />
    <modal-custom v-if="showDeletedModal"
                  title='Something went wrong'
                  text="It looks like the post or comment you were looking for has been deleted!"
                  :successText="`OK`"
                  :hasFooter="true"
                  @modalSuccess="showDeletedModal = !showDeletedModal"
                  :hasClose="true"
                  @modalClose="showDeletedModal = !showDeletedModal">
    </modal-custom>
    <confirm ref="confirmApprove"
             :title="$t('oas.judging.approveModal.title')"
             :text="$t('oas.judging.approveModal.text')"
             :yesText="$t('oas.judging.approveModal.successText')"
             :noText="$t('oas.judging.approveModal.cancelText')"
             :swapButtons="true"
             @yes="approve"
    ></confirm>
    <modal-custom ref="reasonDecline"
            v-if="showOASDecline"
            :title="$t('oas.judging.declineModal.title')"
            :text="declineModalText()"
            :successText="$t('oas.judging.declineModal.successText')"
            :cancelText="$t('oas.judging.declineModal.cancelText')"
            :declineReasonsProp="declineReasons()"
            :isDeclined="true"
            :swapButtons="true"
            :hasFooter="true"
            :showTextBox="true"
            @modalCancel="toggleDeclineModal"
            @selectedReason="decline"
    ></modal-custom>
    <!-- the v-show for the create-inline is always false because it's only used for saving -->
    <div v-if="saving">
      <div v-for="post in displayPosts"
           :key="post.id">
        <create-inline v-show="false"
                       ref="reply"
                       update="true"
                       isJustForSaving="true"
                       v-bind="{post}" />
      </div>
    </div>
    <div class="side-cards-container">
      <user-cards :project="project" :projectQRLink="projectQRLink"></user-cards>
      <judge-rubric-card
          v-if="isSnapshot"
          :projectID="project.id">
      </judge-rubric-card>
      <submission-status-cards
          ref="submissions"
          :submissions="$store.getters.getSubmissions"
          :isSnapshot="isSnapshot"
          @confirmApproval="confirmApproval"
          @reasonDenial="toggleDeclineModal">
      </submission-status-cards>
    </div>
  </div>
</template>

<script>

import Post from '../Post/Grid'
import InfiniteScroll from '@/components/Controls/InfiniteScroll'
import socket from '@/libs/socket'
import Sort from './Sort'
import auth from '@/mixins/auth'
import GridModal from '../Post/Gridmodal'
import comments from '@/api/comments'
import CreateInline from '@/components/Forms/Create/Post'
import Draggable from 'vuedraggable'

import ModalCustom from '@/components/Modals/Custom'
import Confirm from '@/components/Modals/Confirm'
import componentState from '@/mixins/component-state'
import UserCards from '../Header/UserCards'
import JudgeRubricCard from '@/components/SectionProjectView/Header/JudgeRubricCard'
import SubmissionStatusCards from '../Header/SubmissionStatusCards'
import state from '../state'
import mixin from '../tabs'

import projects from '@/api/projects'

export default {
  components: {
    Post,
    InfiniteScroll,
    Sort,
    GridModal,
    ModalCustom,
    Confirm,
    CreateInline,
    Draggable,
    UserCards,
    JudgeRubricCard,
    SubmissionStatusCards
  },
  mixins: [componentState, mixin, auth],
  props: {
    showCreate: {
      type: Boolean
    },
    stateKeyValue: {
      type: String
    },
    fromStartButtonTemplate: {
      type: Boolean
    },
    isSnapshot: {
      type: Boolean
    }
  },
  data: function () {
    return {
      subscribed: false,
      selectedPostID: 0,
      scrollTimer: null,
      dragging: { to: null, from: null },
      reorderMode: false,
      displayPosts: [],
      saving: false,
      showDeletedModal: false,
      tryingToOpenPost: false,
      available: true,
      isef3DBoothLimit: 5,
      showOASDecline: false
    }
  },
  watch: {
    posts: function (newPosts) {
      if (this.displayPosts !== newPosts && this.saving === false) {
        this.displayPosts = this.posts.slice()
      }
    },
    stateKeyValue: function (value) {
      this._setObjectKey(value)
    },
    project: function (project) {
      if (this.targetPostID > 0) {
        this.openPostFromRoute()
      }
    }
  },
  computed: {
    showModal: function () {
      return this._get(state.grid.modalVisible) && this.selectedPostID !== 0
    },
    targetPostID: function () {
      return this.$route ? parseInt(this.$route.query.postID) : 0
    },
    projectRole: function () {
      return this._get(state.project.role, 'none')
    }
  },
  mounted: function () {
    this._setObjectKey(this.stateObjectKeyProp)
    if (!this.subscribed && this.project.id) {
      this.subscribed = true
      socket.subscribe('project', this.project.id, 'grid')
      socket.subscribe('project', this.project.id, 'attachment')
    }

    if (this.targetPostID > 0 && this.project) {
      this.openPostFromRoute()
    }

    if (this.posts.length > 0) {
      this.displayPosts = this.posts.slice()
    }

    this._setObjectKey(this.stateKeyValue)
  },
  created: function () {
    socket.subscribe('getSubmissionStatus', this.project.id)
    this.$socket.onmessage = this.updateStatus
  },
  destroyed: function () {
    if (this.subscribed) {
      this.subscribed = false
      socket.unsubscribe('project', this.project.id, 'grid')
      socket.unsubscribe('project', this.project.id, 'attachment')
    }
    socket.unsubscribe('getSubmissionStatus', this.project.id)
  },
  methods: {
    getIsefFinalist: function (displayPost) {
      if (displayPost && this.$route.name.includes('iseffinalistbooth')) return this.isef3DBoothLimit
      return displayPost.length
    },
    getPostDirection: function (direction = 'next') {
      // Grab post ids
      const postIDs = this.displayPosts.filter(post => {
        return post.id
      }).map(post => {
        return post.id
      })
      // Next
      if (direction === 'next') {
        if (postIDs.indexOf(this.selectedPostID) < postIDs.length - 1) {
          this.selectedPostID = postIDs[postIDs.indexOf(this.selectedPostID) + 1]
        } else {
          this.selectedPostID = postIDs[0]
        }
      } else {
        // Prev
        if (postIDs.indexOf(this.selectedPostID) > 0) {
          this.selectedPostID = postIDs[postIDs.indexOf(this.selectedPostID) - 1]
        } else {
          this.selectedPostID = postIDs[postIDs.length - 1]
        }
      }
    },
    toggleModal: function (value) {
      this._set(state.grid.modalVisible, value)
    },
    confirmApproval: function (event) {
      this.$refs.confirmApprove.show(event)
    },
    approve: function ({ fairId, status }) {
      projects.updateSubmissionStatus(this.project.id, fairId, status).then(() => {
        this.$refs.submissions.$refs[`status${fairId}`][0].submission.status = status
      })
    },
    toggleDeclineModal: function (status) {
      this.showOASDecline = !this.showOASDecline
      this.$nextTick(() => {
        if (status) {
          this.$refs.reasonDecline.declineStatus = status
          this.$refs.reasonDecline.abbreviation = status.abbr
        }
      })
    },
    declineModalText: function () {
      if (this.$store.getters.getSubmissions[0].fair.abbreviation === 'DSD') {
        return this.$t('oas.judging.declineModal.scienceday.reasonText')
      }
      return this.$t('oas.judging.declineModal.bsef.reasonText')
    },
    declineReasons: function () {
      if (this.$store.getters.getSubmissions && ['DSD', 'BSEF', 'SSD'].includes(this.$store.getters.getSubmissions[0].fair.abbreviation)) {
        // science day or bsef
        return [
          { id: 'reasonPayment', Text: this.$t('oas.judging.declineModal.scienceday.reasonPayment') },
          { id: 'reasonQuadChart', Text: this.$t('oas.judging.declineModal.scienceday.reasonQuadChart') },
          { id: 'reasonFinalReport', Text: this.$t('oas.judging.declineModal.scienceday.reasonFinalReport') },
          { id: 'reasonNoAbstract', Text: this.$t('oas.judging.declineModal.scienceday.reasonNoAbstract') },
          { id: 'reasonIsefForms', Text: this.$t('oas.judging.declineModal.scienceday.reasonIsefForms') },
          { id: 'reasonVideo', Text: this.$t('oas.judging.declineModal.scienceday.reasonVideo') }
        ]
      }
      return []
    },
    decline: function ({ reason, status }) {
      const payload = reason[2] !== '' ? `${reason[2]}. ${reason[1]}` : reason[1]
      projects.updateSubmissionStatus(this.project.id, status.fairId, status.status, payload).then(() => {
        this.$refs.submissions.$refs[`status${status.fairId}`][0].submission.status = status.status
        this.toggleDeclineModal()
      })
    },
    showPost: function (id, available) {
      this.available = available
      this.selectedPostID = id
      this._set(state.comments.scrollTo(id), parseInt(this.targetCommentID))
      if (this.targetCommentID) {
        comments.get(this.targetCommentID).then(() => {},
          () => {
            this.showDeletedModal = true
          })
      }
      this.toggleModal(true)
    },
    toggleAvailability: function (value) {
      this.available = value
    },
    scrollToPost: function (id) {
      if (this.scrollTimer) {
        clearTimeout(this.scrollTimer)
      }

      this.scrollTimer = setTimeout(() => {
        this.scrollTimer = null
        const post = document.getElementById(`post-${id}`)
        if (post) {
          post.scrollIntoView({ block: 'center' })
        }
      }, 250)
    },
    savePosts: function () {
      this.saving = true

      this.$nextTick(() => {
        this.$refs.reply.forEach(async (reply) => {
          await reply.saveNoDebounce()
        })
        this._set(state.posts.edit, false)
        this.saving = false
      })
    },
    savePostsOrder: async function () {
      this.reorderMode = false
      this.saving = true
      if (!this.project.customPostOrder) {
        const params = { id: this.project.id, customPostOrder: true }
        this.$store.dispatch('updateCustomPostOrder', params).then((value) => {
          this._set(state.posts.customPostOrder, true)
          this.project.customPostOrder = true
        })
      }
      this.$nextTick(() => {
        this.displayPosts.forEach(async (post, index) => {
          const params = { id: post.id, priority: index }
          this.$store.dispatch('updatePostPriority', params).then((post) => {
            if (index === this.displayPosts.length - 1) {
              const page = 1
              const sort = this._get(state.posts.sortNewest, this.sortNewestFirst) ? 'newest' : 'oldest'
              const limit = this.project.metadata.posts
              const params = { id: this.project.id, limit, sort, page }
              this.$store.dispatch('getProjectPosts', params).then(() => {
                this.saving = false
              })
            }
          })
        })
      })
    },
    resetPosts: function () {
      this.reorderMode = false
      this.displayPosts = this.posts.slice()
    },
    enterReorderMode: function () {
      this._set(state.project.defaultFirstToLast, true)
      if (this.displayPosts.length < this.project.metadata.posts) {
        this._set(state.posts.loading, true)
        const page = 1
        const sort = 'oldest'
        const limit = this.project.metadata.posts
        const params = { id: this.project.id, limit, sort, page }
        this.$store.dispatch('getProjectPosts', params).then(() => {
          this.saving = false
          this.reorderMode = true
          this._set(state.posts.loading, false)
        })
      } else {
        this.reorderMode = true
      }
    },
    openPostFromRoute: function () {
      if (this.tryingToOpenPost || !this.targetPostID || !this.project.id) {
        return
      }
      const targetPostID = this.targetPostID

      this.tryingToOpenPost = true
      this.$store.dispatch('getPost', { id: targetPostID, force: false }).then(() => {
        this.showPost(targetPostID, true)
        this.scrollToPost(targetPostID)
      }).catch(() => {
        this.showDeletedModal = true
        this.tryingToOpenPost = false
      }).then(() => {
        const query = Object.assign({}, this.$route.query)
        delete query.postID
        delete query.commentID
        delete query.reply
        this.$router.replace({ query })
        const sort = this._get(state.posts.sortNewest, this.sortNewestFirst) ? 'newest' : 'oldest'
        const params = { id: this.project.id, limit: 13, sort, page: 1 }
        this.$store.dispatch('getProjectPosts', params)
        this.tryingToOpenPost = false
      })
    },
    updateStatus: function ({ data }) {
      const { payload: { id, action } } = JSON.parse(data)
      this.$store.dispatch(action, { id })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';
.moving-card {
  background: var(--background-fifth);
  border-radius: 1px;
}

.reorder {
  width: 100%;
}

.reorder-button, .save-button, .cancel-button {
  margin-top: 0.5rem;
  height: 100%;
  align-items: center;
  justify-content: center;
  margin-right: 0.5rem;
  letter-spacing: 0.04rem;
  font-size: 0.65rem;
  padding: 0.25rem 0;
@include mobile {
  font-size: 0.55rem;
}
}

.save-button {
  color: $white;
}

.reorder-button {
  color: $grey-dark;
}

.backColor{
  position: relative;
}

.columns{
  margin:0 auto;
  background:#fff;
  padding: 0 0.5rem;
@include mobile {
  padding: 0;
}
}

.loader {
  display: block;
  font-size: 2rem;
  margin: 1rem auto;
}

.slide-enter-active {
  animation: slide-in 1s ease-out forwards;
}

.slide-leave-active {
  animation: slide-out 0.5s ease-out forwards;
}

@keyframes slide-in {
  from {
    transform: translateY(45vh);
    opacity:0;
  }
  to {
    transform: translateY(0);
    opacity:1;
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0px);
    opacity:1;
  }
  to {
    transform: translateY(20vh);
    opacity:0;
  }
}

.slide-move{
  transition: transform 1s;
}

.column.is-one-third{
&.reorder-mode {
   padding: 0.3rem;
 }
padding: 0.09rem;
}
.side-cards-container {
  top: calc(83px);
  right: calc(50vw - 630px);
  position: fixed;
  z-index: 5;
  position: fixed;
  display: flex;
  flex-direction: column;
  height: 100vh;
}
@media only screen and (max-width: 767px) {
  .side-cards-container {
    position: relative !important;
    right: unset !important;
    top: unset !important;
    padding-top: 20px;
    height: 100% !important;
  }
  .gridTab.component {
    background: #F2F2F2;
    padding: 15px;
    margin-top: 90px;
  }
}
</style>
